import { useState, useEffect, useContext } from "react";
import doctor from "../../assets/images/doctor_dummy.jpg";
import { useNavigate } from "react-router-dom";
import DoctorProvider from "../../Provider/DoctorProvider";

const DoctorCardNew = ({ doctorData }) => {
  const navigate = useNavigate();
  const { getDoctorData } = useContext(DoctorProvider);
  // console.log("doctor", doctorData);

  return (
    <div className="bg-white py-[20px] px-[20px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] mt-[15px] rounded-2xl">
      <div className="flex justify-between items-center flex-col sm:flex-row ">
        <div className="flex items-center justify-between  w-full sm:w-auto gap-[1.5rem] ">
          {/* <img
            src={doctor}
            className="w-[100px] h-[100px] rounded-[50%] object-cover "
          /> */}
        
          <img
            src={`${process.env.REACT_APP_BASE}${doctorData?.image}`}
            className="w-[100px] h-[100px] rounded-[50%] object-cover cursor-pointer flex-none "
            onClick={() => {
              navigate(`/doctor/${doctorData?.slug}`);
              getDoctorData(doctorData?.slug);
            }}
          />
          <div className="w-full sm-w-auto flex-1">
            <h3
              className="cursor-pointer font-secondary font-bold text-black text-[20px] hover:text-primary "
              onClick={() => {
                navigate(`/doctor/${doctorData?.slug}`);
                getDoctorData(doctorData?.slug);
              }}
            >
              Dr. {doctorData?.name}
            </h3>
            <p className="font-secondary font-normal text-black text-[14px] mt-[5px]">
              {`Year of Experience - ${doctorData?.experience} year${
                doctorData?.experience > 1 ? "s" : ""
              }`}
            </p>
            <p className="font-secondary font-normal text-lightgray text-[12px] mt-[5px]">
              {doctorData?.specialization &&
              doctorData?.specialization.length > 0 ? (
                doctorData?.specialization.map((item, index, array) => {
                  if (array.length === 1) {
                    return item; // Return directly if only one specialization
                  }
                  if (index < array.length - 1) {
                    return `${item}, `;
                  } else {
                    return `and ${item}`; // Add "and" before the last item
                  }
                })
              ) : (
                <span>No specializations available</span>
              )}
            </p>
            <div
              className=" font-secondary font-medium text-[14px]  text-primary cursor-pointer mt-5 block sm:hidden"
              onClick={() => {
                navigate(`/doctor/${doctorData?.slug}`);
                getDoctorData(doctorData?.slug);
              }}
            >
              View Details
            </div>
          </div>
        </div>
        <div
          className="font-secondary font-medium text-[14px]  text-primary cursor-pointer hidden sm:block w-[100px]"
          onClick={() => {
            navigate(`/doctor/${doctorData?.slug}`);
            getDoctorData(doctorData?.slug);
          }}
        >
          View Details
        </div>
      </div>
    </div>
  );
};

export default DoctorCardNew;
